import constant from "../constant";
const initialState = {
  loaded: false,
  loading: false,
  data: {}
};

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case constant.DASHBOARD_LOADING:
      return { ...state, loading: true };
    case constant.UPDATE_DASHBOARD:
      return { loaded: true, loading: false, data: action.payload };
    default:
      return state;
  }
}



export default dashboard;